import BaseApi from './BaseApi'

export default class ImeiApi extends BaseApi {
  static async getCities() {
    return this.get(`/rest/cities`)
  }
}
